const TransferUnits = [
  { factor: 10 ** 6, label: 'Mbps' },
  { factor: 10 ** 9, label: 'Gbps' }
];

export default TransferUnits;
